<template>
    <loading :active="loading"
             :can-cancel="true"
             :on-cancel="onCancel"
             :is-full-page="true"></loading>

    <modalView class="z-50" v-if="address_search_open" @close-modal="address_search_open = false" :harf="false"  >
        <autoshipagreetext @close_address_search="close_address_search"  />
    </modalView>
    <modalView class="z-50" v-if="guide_search_open" @close-modal="guide_search_open = false" :harf="false"  >
        <autoshipguidetext @close_address_search="close_guide"  />
    </modalView>

    <section class="bg-[#f0f2f4]">
        <div class="container mx-auto py-6">
            <div class="max-w-8xl mx-auto px-4 sm:py-6 sm:px-6 lg:max-w-7xl lg:px-8">
                <div class="w-full">
                    <div class="flex justify-start item-start space-y-2 flex-col">
                        <h1 class="text-2xl  font-semibold leading-7 lg:leading-9 text-gray-800 mb-2 lg:mb-6">注文情報</h1>
                    </div>

                    <div class="w-full lg:flex lg:justify-start">

                        <div class="w-full lg:w-2/3 ">
                            <!-- 주문자 정보 -->
                            <div class="flex flex-col justify-start items-start w-full mb-6 shadow-zinc-500/40 shadow-md rounded-md xl:mt-0 lg:mt-0 mt-4">
                                <p class="text-lg xl:text-xl lg:text-xl  font-semibold leading-6 xl:leading-5 text-gray-800 flex items-center justify-between w-full cursor-pointer xl:px-6 lg:px-6 px-4 xl:py-6 lg:py-6 py-4 bg-white rounded-md" v-on:click="showMessage2 = !showMessage2">
                                    <span class="border-l-[10px] border-[#4493d5] pl-3 xl:pt-2 lg:pt-2 xl:pb-2 lg:pb-2">情報</span>
                                    <svg class="w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"></path></svg>
                                </p>
                                <div class="w-full p-4 xl:grid lg:grid xl:grid-cols-2 lg:grid-cols-2 block bg-white rounded-bl-md rounded-br-md" v-if="showMessage2">
                                    <div class="flex justify-start items-start flex-col space-y-4 mt-2 border-b lg:border-0 xl:border-0 p-2">
                                        <p class="text-base  font-semibold leading-4 text-left text-[#2c7fc3] lg:text-lg">注文履歴</p>
                                        <p class="w-full dark:text-gray-300 text-left text-sm leading-5 text-[#0e293e]">{{ order_info_list.o_name }} <br> {{ order_info_list.d_mobile }}</p>
                                    </div>
                                    <div class="flex justify-start items-start flex-col space-y-4 mt-2 border-b lg:border-0 xl:border-0 p-2">
                                        <p class="text-base  font-semibold leading-4 text-left text-[#2c7fc3] lg:text-lg">配送情報</p>
                                        <p class="w-full dark:text-gray-300 text-left text-sm leading-5 text-[#0e293e]">
                                            {{ request["postcode"]}} {{ request["address2_1"]}} {{ request["address2_2"]}} </p>
                                    </div>
                                    <div class="flex justify-start items-start flex-col space-y-4 mt-2 border-b lg:border-0 xl:border-0 p-2" v-show="false">
                                        <p class="text-base  font-semibold leading-4 text-left text-[#2c7fc3] lg:text-lg">Billing Address</p>
                                        <p class="w-full dark:text-gray-300 text-left text-sm leading-5 text-[#0e293e]">
                                            {{ order_info_list.o_name }}<br>{{ order_info_list.o_mobile }}<br>
                                            {{ order_info_list.o_post }} {{ order_info_list.o_addr2 }} {{ order_info_list.o_addr1 }}
                                        </p>
                                    </div>
                                    <div v-show="false" class="flex justify-start items-start flex-col space-y-4 mt-2 p-2">
                                        <p class="text-base  font-semibold leading-4 text-left text-[#2c7fc3] lg:text-lg">Contact Help</p>
                                        <p class="w-full dark:text-gray-300 text-left text-sm leading-5 text-[#0e293e]">info.us@gcoop.com</p>
                                    </div>
                                </div>
                            </div>
                            <!-- 제품 리스트 -->
                            <div class="flex flex-col justify-start items-start shadow-zinc-500/40 shadow-md rounded-md">
                                <div class="flex flex-col justify-start items-start w-full rounded-md">
                                    <p class="text-lg xl:text-xl lg:text-xl  font-semibold leading-6 xl:leading-5 text-gray-800 flex items-center justify-between w-full cursor-pointer xl:px-6 lg:px-6 px-4 xl:py-6 lg:py-6 py-4 bg-white rounded-md" v-on:click="showMessage = !showMessage">
                                        <span class="border-l-[10px] border-[#4493d5] pl-3 xl:pt-2 lg:pt-2 xl:pb-2 lg:pb-2">注文製品 <span class="">({{ order_product_list.length }})</span></span>
                                        <svg class="w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                                    </p>
                                    <div class="bg-white xl:px-4 lg:px-4 xl:py-4 lg:py-4 rounded-bl-md rounded-br-md w-full" v-if="showMessage">
                                        <div v-for="(product, i) in order_product_list" :key="product.seq_pd" class="flex w-full border-b border-dotted border-gray-300 mb-2 p-3 last:border-b-0">
                                            <div class="relative xl:w-1/5 lg:w-1/5 w-1/3">
                                                <div class="aspect-w-1 aspect-h-1 rounded-md overflow-hidden aspect-square border">
                                                    <img class="w-full hidden md:block" v-bind:src="'https://cdn.gcoop.me/public' + product.images[0].path + '/' + product.images[0].filename" v-bind:alt=" product.images[0].filename "  alt="{{ product.product.pdt_name }}" />
                                                    <img class="w-full md:hidden" v-bind:src="'https://cdn.gcoop.me/public' + product.images[0].path + '/' + product.images[0].filename" v-bind:alt=" product.images[0].filename " alt="{{ product.product.pdt_name }}" />
                                                    <div class="sold-out-box2" v-if="product.product.status == 2">
                                                        <img src="/images/badge/us/pc_temp_sold_out.png" alt="sold out" />
                                                    </div>
                                                    <div class="sold-out-box2" v-if="product.product.status == 3">
                                                        <img src="/images/badge/us/pc_sold_out.png" alt="sold out" />
                                                    </div>
                                                    <div class="coming_box" v-if="product.product.status == 4">
                                                        <img src="/images/badge/us/pc_coming_soon.png" alt="sold out" />
                                                    </div>
                                                    <div class="badge_box" v-if="product.product.badges.image_url">
                                                        <img v-bind:src="'https://cdn.gcoop.me/' + product.product.badges.image_url" alt="sold out" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex-col flex justify-between items-start w-full pt-3 pb-2 space-y-4 md:space-y-0 pl-4">
                                                <div class="w-full flex flex-col justify-start items-start space-y-8 mb-2">
                                                    <h3 class=" xl:text-lg lg:text-lg text-md font-semibold leading-6 text-[#0e293e]">{{ product.product.pdt_name }}</h3>
                                                </div>
                                                <div class="text-red-500 text-md" v-if="product.product.deli_date2" v-html="product.product.deli_date2"></div>
                                                <div class=" w-full">
                                                    <p class="text-xs ">{{ formatPrice(product.price) }}円 / <span class="text-blue-500">PV {{ formatPrice(product.pv,2) }}</span></p>
                                                    <div class="flex justify-end flex-col">
                                                        <p class="xl:text-md lg:text-md  font-semibold text-gray-800 xl:text-right lg:text-right mb-1">数量 : {{ product.qty }}</p>
                                                        <p class="xl:text-md lg:text-md  font-semibold text-gray-800 xl:text-right lg:text-right">{{ formatPrice(product.amt * product.qty) }}円 / <span class="text-blue-500">PV {{ formatPrice(product.pv * product.qty,2) }} </span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- // 제품 리스트 -->
                        </div>
                        <div class="w-full lg:w-1/3 px-2">
                            <!-- 결제유형 선택 -->
                            <div class="w-full" id="app">
<!--                                <div class="w-full xl:px-4 lg:px-4">-->
<!--                                    <button @click="guide_search_open = true" class="bg-lime-500 mb-3 font-semibold hover:bg-lime-600 py-3 text-base text-white uppercase w-full">【 定期購入利用ガイド 】</button>-->
<!--                                </div>-->

                                <div class="flex justify-start w-full xl:px-4 lg:px-4 xl:pb-4 lg:pb-4 xl:mt-0 lg:mt-0 mt-4">
                                    <div class="flex flex-col justify-center px-4 py-6 md:p-6 xl:p-6 w-full bg-white dark:bg-gray-800 space-y-6 shadow-zinc-500/40 shadow-md rounded-md">
                                        <h3 class="text-lg xl:text-xl lg:text-xl  font-semibold leading-5 text-gray-800 border-l-[10px] border-[#4493d5] pl-3">決済方法<br>
                                            <p class="text-[#2c7fc3] text-xs font-semibold">( 決済方法を選択してください )</p>
                                        </h3>
                                        <!-- 결제수단  -->
                                        <div class="w-full pay_box">
                                            <div class="w-full text-lg flex items-center" @click="key = 1">
                                                <input type="radio" id="paytype1" name="paytype" class="hidden" :checked="key == '1'">
                                                <label for="paytype1" class="bg-white text-gray-800 border border-gray-300 font-semibold px-4 py-1 cursor-pointer rounded-md block text-center h-12 flex items-center justify-center w-full">
                                                <span class="flex">
                                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="w-6"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M168 336C181.3 336 192 346.7 192 360C192 373.3 181.3 384 168 384H120C106.7 384 96 373.3 96 360C96 346.7 106.7 336 120 336H168zM360 336C373.3 336 384 346.7 384 360C384 373.3 373.3 384 360 384H248C234.7 384 224 373.3 224 360C224 346.7 234.7 336 248 336H360zM512 32C547.3 32 576 60.65 576 96V416C576 451.3 547.3 480 512 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H512zM512 80H64C55.16 80 48 87.16 48 96V128H528V96C528 87.16 520.8 80 512 80zM528 224H48V416C48 424.8 55.16 432 64 432H512C520.8 432 528 424.8 528 416V224z"/></svg>
                                                  &nbsp;Card
                                                </span>
                                                </label>
                                            </div>
                                            <div class="grid grid-cols-2 gap-2 mt-2" v-show="false">
                                                <div class="w-full xl:text-base lg:text-base text-sm" @click="key = 2">
                                                    <input type="radio" id="paytype2" name="paytype" class="hidden">
                                                    <label for="paytype2" class="bg-white text-gray-800 border border-gray-300 font-semibold px-4 py-1 cursor-pointer rounded-md block text-center h-12 flex items-center justify-center">
                                                        Pay-easy
                                                    </label>
                                                </div>
                                                <div class="w-full xl:text-base lg:text-base text-sm" @click="key = 3">
                                                    <input type="radio" id="paytype5" name="paytype" class="hidden">
                                                    <label for="paytype5" class="bg-white text-gray-800 border border-gray-300 font-semibold px-4 py-1 cursor-pointer rounded-md block text-center h-12 flex items-center justify-center">
                                                        コンビニ決済
                                                    </label>
                                                </div>
                                            </div>

                                        </div>
                                        <!-- 결제수단 콘텐츠 영역 -->
                                        <div v-show="visible_payment_area && key == 1"> <!--v-if="key == 1"-->
                                            <h5 class="font-bold before_cont text-[#2c7fc3]">定期購入の次回決済指定日</h5>
                                            <div class="mt-4 my-2">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">
                                                    <select class="w-full rounded-md border-gray-300 text-sm md:text-base md:mr-0.5 " v-model="admits_day">
                                                        <option value="1">1日</option>
                                                        <option value="11">11日</option>
                                                        <option value="21">21日</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <h5 class="font-bold before_cont text-[#2c7fc3]">Card</h5>
                                            <div class="mt-4">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">
                                                    <input name="card_no" id="card_no" ref="card_no" type="text" placeholder=" "
                                                           class="md-input w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600  cursor-pointer" maxlength="16"
                                                           v-model="card_no">
                                                    <label for="card_no" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">カード番号</label>
                                                </div>
                                            </div>
                                            <div class="mt-4 flex space-x-4 mt-4 ">
                                                <div class="md-input-box relative z-[10] bg-white w-1/2">
                                                    <input name="valid_date" id="valid_date" ref="valid_date" type="text" placeholder=" "
                                                           class="md-input w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600  cursor-pointer" maxlength="4"
                                                           v-model="valid_date">
                                                    <label for="valid_date" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">MM/YY</label>
                                                </div>
                                                <div class="md-input-box relative z-[10] bg-white w-1/2">
                                                    <input name="cvv" id="cvv" ref="cvv" type="text" placeholder=" "
                                                           class="md-input w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600  cursor-pointer" maxlength="4"
                                                           v-model="cvv">
                                                    <label for="cvv" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">CCV</label>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">
                                                    <input name="e_mail" id="e_mail" ref="e_mail" type="text" placeholder=" "
                                                           class="md-input w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600  cursor-pointer"
                                                           v-model="e_mail">
                                                    <label for="e_mail" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">E-mail</label>
                                                </div>
                                            </div>

                                        </div>
                                        <div v-show="visible_payment_area && key == 2"> <!--v-if="key == 1"-->
                                            <h5 class="font-bold before_cont text-[#2c7fc3]">Pay-easy</h5>
                                            <div class="mt-4">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">

                                                    <input name="valid_date" id="valid_date" ref="valid_date" type="text" placeholder=" "
                                                           class="md-input w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600  cursor-pointer"
                                                           v-model="bankKana">
                                                    <label for="valid_date" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">カタカナ名</label>
                                                    <div style="font-size:.8rem; color:#ff5959; margin-bottom:8px; font-weight: bold; word-break: break-word;">
                                                        ※必ずカタカナでご入力下さい。
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">

                                                    <label for="valid_date" style="transform: translate(0px, -15px) scale(1);" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">決済サービスオプション</label>

                                                    <select name="price_open" id="price_open" class="mt-2 mb-2 w-full border border-gray-300 rounded text-sm md:text-base" v-model="payeasySelect">
                                                        <option value="netbank-pc" selected>ネットバンキング</option>
                                                        <option value="ATM">ATM</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">
                                                    <input name="e_mail" id="e_mail" ref="e_mail" type="text" placeholder=" "
                                                           class="md-input w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600  cursor-pointer"
                                                           v-model="e_mail">
                                                    <label for="e_mail" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">E-mail</label>
                                                </div>
                                                <div style="font-size:.8rem; color:#ff5959; margin-bottom:8px; font-weight: bold; word-break: break-word;">
                                                    ※ ご入力頂いたメールアドレスに確認用メールを送信しております。
                                                </div>

                                            </div>

                                        </div>
                                        <div v-show="visible_payment_area && key == 3"> <!--v-if="key == 1"-->
                                            <h5 class="font-bold before_cont text-[#2c7fc3]">コンビニ決済</h5>
                                            <div class="mt-4">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">

                                                    <label for="valid_date" style="transform: translate(0px, -15px) scale(1);" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">決済サービスオプション</label>

                                                    <select name="price_open" id="price_open" class="mt-2 mb-2 w-full border border-gray-300 rounded text-sm md:text-base" v-model="cvsSelect">
                                                        <option value="econ" selected> イーコン（ローソン、ファミリーマート、ミニストップ、セイコーマート）</option>
                                                        <option value="other">その他(デイリーヤマザキ)</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <div class="md-input-box relative z-[10] w-full bg-white w-full">
                                                    <input name="e_mail" id="e_mail" ref="e_mail" type="text" placeholder=" "
                                                           class="md-input w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600  cursor-pointer"
                                                           v-model="e_mail">
                                                    <label for="e_mail" class="md-label block mb-3 text-sm font-semibold text-[#2c7fc3]">E-mail</label>
                                                </div>
                                                <div style="font-size:.8rem; color:#ff5959; margin-bottom:8px; font-weight: bold; word-break: break-word;">
                                                    ※ ご入力頂いたメールアドレスに確認用メールを送信しております。
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 총합계 -->
                            <div class="flex justify-center flex-col md:flex-row flex-col items-stretch w-full mt-4 xl:px-4 lg:px-4 xl:pb-4 lg:pb-4 ">
                                <div class="flex flex-col px-4 py-6 md:p-6 xl:p-6 w-full bg-white dark:bg-gray-800 space-y-6 shadow-zinc-500/40 shadow-md rounded-md">

                                    <h3 class="text-lg xl:text-xl lg:text-xl  font-semibold leading-5 text-gray-800 border-l-[10px] border-[#4493d5] pl-3">決済金額</h3>

                                    <div class="flex justify-center items-center w-full space-y-4 flex-col border-gray-200 border-b pb-4">
                                        <div class="flex justify-between w-full">
                                            <p class="text-base  leading-4 text-gray-800">合計金額</p>
                                            <p class="text-base text-right dark:text-gray-300 leading-4 text-gray-800">
                                                {{ formatPrice(sum_item.amt - shipping_selected) }}円
                                            <p class="text-blue-500 text-right mt-2">PV {{ formatPrice(sum_item.bv,2) }} </p>
                                            </p>
                                        </div>
                                        <div class="flex justify-between w-full">
                                            <p class="text-base  leading-4 text-gray-800">送料</p>
                                            <p class="text-base dark:text-gray-300 leading-4 text-gray-800 text-right">
                                                {{ formatPrice(parseFloat(shipping_selected)) }}円
                                            </p>
                                        </div>
                                        <div class="flex justify-between w-full" v-if="key == '4'">
                                            <p class="text-base  leading-4 text-gray-800">Point</p>
                                            <p class="text-base dark:text-gray-300 leading-4 text-gray-800 text-right">
                                                - {{ formatPrice(cur_point,2) }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex justify-between items-center w-full pb-4">
                                        <p class="text-base  font-semibold leading-4 text-gray-800">決済金額</p>
                                        <div class="text-base dark:text-gray-300 font-semibold leading-4 text-gray-600">
                                            <p class="text-right xl:text-2xl lg:text-2xl text-xl font-bold font-bold text-gray-900">{{  formatPrice(total_amt) }}円</p>
                                            <p class="xl:text-2xl lg:text-2xl text-xl text-blue-500 text-right font-bold mt-2">PV {{ formatPrice(sum_item.bv,2) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="payment-agree w-full xl:px-4 lg:px-4">
                                <input type="checkbox" id="check_agree_uselaw" v-model="check_agree_uselaw" value = "1" class="blind">
                                <label for="check_agree_uselaw">
                                    <span class="text-sm font-semibold text-gray-500 cursor-pointer">
                                        定期購入利用規約に同意
                                        <a href="#" @click="address_search_open = true">
                                            [全文を読む]
                                        </a>
                                    </span>
                                </label>
                            </div>
                            <div class="w-full xl:px-4 lg:px-4">
                                <button @click="go_pay" v-show="is_payment == true && is_first == true" class="bg-[#2c80c4] font-semibold hover:bg-[#2468a0] py-3 text-sm text-white uppercase w-full">決済</button>
                                <button @click="go_pay" v-show="is_payment == true && is_first == false && is_manual == true" class="bg-[#2c80c4] font-semibold hover:bg-[#2468a0] py-3 text-sm text-white uppercase w-full">決済</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <form name="frmPayment">
        <input type="hidden" name="_token">
        <input type="hidden" id="token_api_key" value="8a42ac09-7266-47f5-b998-4a28f070a784">
        <input type="hidden" name="TransactionType" value="SALE">
        <input type="hidden" name="PymtMethod" value="CC"> <!-- 정기구매 첫결제 : CC , 일반결제 any -->
        <input type="hidden" name="ServiceID" value="GPO">
        <input type="hidden" name="PaymentID">
        <input type="hidden" name="OrderNumber">
        <input type="hidden" name="PaymentDesc" value="GCOOP Malaysia">
        <input type="hidden" name="MerchantName" value="GCOOP Malaysia Sdn. Bhd.">
        <input type="hidden" name="MerchantReturnURL">
        <input type="hidden" name="MerchantCallbackURL">
        <input type="hidden" name="Amount">
        <input type="hidden" name="CurrencyCode" value="MYR">
        <input type="hidden" name="CustIP">
        <input type="hidden" name="CustName">
        <input type="hidden" name="CustEmail">
        <input type="hidden" name="CustPhone">
        <input type="hidden" name="HashValue">
        <input type="hidden" name="MerchantTermsURL" value="https://cdn.gcoop.me/shop/storage/pdf/my/terms_mal.pdf">
        <input type="hidden" name="LanguageCode" value="en">
        <input type="hidden" name="PageTimeout" value="780">
    </form>
</template>
<script>
/* javascript numberFormat library */
import numeral from 'numeral';
import 'numeral/locales';
import modalView from "../modalView";
import alert from "vue3-simple-alert";
import VueSimpleAlert from "vue3-simple-alert";
import Loading from 'vue3-loading-overlay';

let itemsToShow  = 1;

export default {
    name: "Order",
    components : {
        modalView,
        Loading
    },

    props: ['request','hashdata'],
    setup() {
        return {
            // products,
        }
    },
    data: () => ({
        showMessage: true,
        showMessage2: true,
        title: [],
        order_list: [],
        order_info_list: [],
        order_pay_list: [],
        order_product_list: [],
        sum_item: [],
        // fee_shipping: [],
        shipping_selected: 0,
        csrf: document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').content : '',
        is_order_possible : window.Laravel.is_order_possible,
        key : 1,
        loading : false,
        weachat_open :false,
        is_mobile : itemsToShow,
        card_no : "",
        valid_date : "",
        cvv : "",
        first_name : "",
        last_name : "",
        e_mail : "",
        deli_kind : "",
        deli_kinds : "",
        insurance_fee : "",
        gel_price : "",
        price_open : "",
        pay_agree : "",
        pay_agree2 : "",
        pay_agree2_show : true,
        cur_point : 0,
        usable_point : 0,
        visible_payment_area : true,
        cvsSelect : "econ",
        payeasySelect : "netbank-pc",
        bankKana : "",
        is_payment : false,
        is_first : false,
        is_manual : false,
        autoship_products : [],
        address_search_open : false,
        guide_search_open : false,
        check_agree_uselaw : 0,
        admits_day : "",

        //orderer: orderer
    }),
    created() {
        this.order = this.request["order_seq"];
        this.sum_item.price = 0;
        this.sum_item.vat = 0;
        this.sum_item.amt = 0;
        this.sum_item.bv = 0;
        this.shipping_selected = 0;
        this.getCheck4WeekOrder();
        this.getOrder(window.Laravel.bz_cd);
    },
    methods:{

        getOrder(bz_cd) {
            axios.post(process.env.MIX_BACK_URL + '/api/getOrder', {
                order: this.order,
                bz_cd: bz_cd,
            }, {headers: {Authorization: 'Bearer ' + window.Laravel.access_token}})
                .then(response => {
                    this.order_list = response.data;
                    this.order_info_list= response.data.info;
                    this.order_info_list.d_addr2 = this.order_info_list.d_addr2.replaceAll("|@|", ", ");
                    this.order_info_list.d_addr1 = this.order_info_list.d_addr1.replaceAll("|@|", ", ");
                    this.order_info_list.o_addr1 = this.order_info_list.o_addr1.replaceAll("|@|", ", ");
                    this.order_info_list.o_addr2 = this.order_info_list.o_addr2.replaceAll("|@|", ", ");
                    this.order_pay_list= response.data.pay;
                    this.order_product_list= response.data.product;
                    this.sum_item.price = this.order_list.ord_price;
                    this.sum_item.vat = this.order_list.ord_vat;
                    this.sum_item.amt = this.order_list.ord_amt;
                    this.sum_item.bv = this.order_list.ord_pv;
                    this.total_amt = this.sum_item.amt;
                    this.shipping_selected = this.order_list.ord_deli_amt;
                    this.totalCost();
                    // this.totalCost(this.order_product_list);  //  결제상품 총액 / 배송비 포함 실결제액
                    // this.title = response.data[0].cate_name;

                })
                .catch(e => {
                    // window.history.go(-1);
                });
        },
        // 합산 금액 합산
        totalCost(){  // 토탈 금액 합산 기능
            this.total_cost = parseFloat(this.sum_item.amt);
            if(this.tax_selected) this.total_cost += parseFloat(this.tax_selected);
        },
        getCheck4WeekOrder(){
            axios.post(process.env.MIX_BACK_URL+'/api/getCheck4WeekOrder',{
                bz_cd: window.Laravel.bz_cd,
            },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }})
                .then(response => {
                    // this.shipping_info["d_state"] = value;
                    this.is_payment = response.data.is_payment;
                    this.is_first = response.data.is_first;
                    this.is_manual = response.data.is_manual;

                    // console.log(this.state_list);
                })
                .catch(e => {
                });

        },

        // 장바구니 가져오기
        /*    getCart(bz_cd){
              axios.post(process.env.MIX_BACK_URL+'/api/cart',{
                bz_cd: bz_cd,
              },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }})
                .then(response => {
                  // this.title = response.data[0].cate_name;
                  if(response.data.length) {
                    this.products = response.data;
                    // console.log(this.request);
                    this.shipping_selected = this.request['shipping_fee']??0; // 배송비
                    this.tax_selected = this.request['tax_fee']??0; // 택스
                    this.totalCost(this.products);  //  결제상품 총액 / 배송비 포함 실결제액
                  }else{
                    // console.log(response.data);
                    window.history.go(-1);
                  }
                })
                .catch(e => {
                  window.history.go(-1);
                });
            },*/
        // 수량 변경
        /*    decrement(e,i){
              if(this.products[i].qty > 1) {
                this.products[i].qty--;
                this.totalCost(this.products);
                this.setChangeQty(this.products[i].seq_pd,this.products[i].qty);
              }
            },
            increment(e,i){
              if(this.products[i].qty < this.max_qty) {
                this.products[i].qty++;
                this.totalCost(this.products);
                this.setChangeQty(this.products[i].seq_pd,this.products[i].qty);
              }
            },
            changeQty(e,i){
              if(this.products[i].qty < 1) {
                this.products[i].qty = 1;
                this.totalCost(this.products);
                this.setChangeQty(this.products[i].seq_pd,this.products[i].qty);
              }
              if(this.products[i].qty > this.max_qty) {
                this.products[i].qty = this.max_qty;
                this.totalCost(this.products);
                this.setChangeQty(this.products[i].seq_pd,this.products[i].qty);
              }
            },
            setChangeQty(item, qty){
              axios.post(process.env.MIX_BACK_URL+'/api/change_qty',{
                item: item,
                qty: qty,
              },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }})
                .then(response => {
                  console.log(response.data);
                  if(response.data.msg){
                    alert(response.data.msg);
                  }

                });
            },*/
        // 장바구니 아이템 삭제
        /*    removeItem(e,i){
              axios.post(process.env.MIX_BACK_URL+'/api/remove_cart',{
                item: this.products[i].seq_pd,
              },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }})
                .then(response => {
                  console.log(response.data);
                  if(response.data.msg){
                    alert(response.data.msg);
                  }
                  this.getCart(window.Laravel.bz_cd);
                });
            },*/
        // 쇼핑 계속하기
        prevUrl(){
            // console.log(window.history);
            window.history.go(-1);//
            // this.$router.go（-1）;
        },
        // 장바구니 금액 합산
        /*   totalCost(data){  // 토탈 금액 합산 기능
             this.sum_item.price = this.sumPrice(data);
             this.sum_item.vat = this.sumVat(data);
             this.sum_item.amt = this.sumAmt(data);
             this.sum_item.bv = this.sumBV(data);
             this.total_cost = this.sum_item.amt;
             if(this.shipping_selected) this.total_cost += parseFloat(this.shipping_selected);
             if(this.tax_selected) this.total_cost += parseFloat(this.tax_selected);
           },*/
        /*   sumPrice(data) { // 상품 금액 * 수량 합산
             return [].concat.apply([],
               data.map(el => el))
               .reduce((acc, el) => acc + +(el.prices.price*el.qty), 0);
           },
           sumVat(data) { // 상품 금액 * 수량 합산
             return [].concat.apply([],
               data.map(el => el))
               .reduce((acc, el) => acc + +(el.prices.vat*el.qty), 0);
           },
           sumAmt(data) { // 상품 금액 * 수량 합산
             return [].concat.apply([],
               data.map(el => el))
               .reduce((acc, el) => acc + +(el.prices.amt*el.qty), 0);
           },
           sumBV(data) { // 상품 금액 * 수량 합산
             return [].concat.apply([],
               data.map(el => el))
               .reduce((acc, el) => acc + +(el.prices.pv*el.qty), 0);
           },
           change_shipping_fee(){  // 배송비 합산
             this.totalCost(this.products);
             // this.total_cost = this.add_shipping_fee();
           },
           change_tax_fee(){
             this.totalCost(this.products);
           },*/
        // 숫자 포멧
        formatPrice(value,digit) {
            let val = (value/1).toFixed(digit).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        checkCardInvalid(){
            if(this.card_no == ""){
                VueSimpleAlert.alert("カード番号を入力してください","","",{confirmButtonText:"確認"});
                return false;
            }
            if(this.valid_date == ""){
                VueSimpleAlert.alert("有効期限を入力してください","","",{confirmButtonText:"確認"});
                return false;
            }

            if(this.cvv == ""){
                VueSimpleAlert.alert("CVVを入力してください","","",{confirmButtonText:"確認"});
                return false;
            }
            return true;
        },

        go_pay(){
            this.loading = true;

            // console.log(this.key);
            if(!this.check_agree_uselaw){
                VueSimpleAlert.alert("購入条件に同意してください","","",{confirmButtonText:"確認"});
                this.loading = false;
                return;
            }

            if(!this.admits_day){
                this.loading = false;
                VueSimpleAlert.alert("定期購入次の決済日を選択してください。","","",{confirmButtonText:"確認"});
                return;
            }

            if(parseInt(this.sum_item.bv) < 100) { // 최소 100PV 이상 정기구매 주문 가능
              this.loading = false;
              VueSimpleAlert.alert("定期購入のカートの構成が100PV未満です。決済するには100PV以上の構成が必要です。","","",{confirmButtonText:"確認"});
              return;
            }

            if(this.key == "4"){
                if(parseFloat(this.cur_point) < parseFloat(this.sum_item.amt)){
                    if(this.checkCardInvalid() == false){
                        return;
                    }
                }
            }else if(this.key == "1"){
                if(this.checkCardInvalid() == false){
                    return;
                }
            }
            var pay_kind = 0;
            var token  = "";

            if(this.key == 1){
                var data = {};
                data.token_api_key = document.getElementById('token_api_key').value;
                if (this.card_no) {
                    data.card_number = this.card_no;
                }
                if (this.valid_date) {
                    data.card_expire = this.valid_date.substring(0,2)+"/"+this.valid_date.substring(2,4);
                }
                if (this.cvv) {
                    data.security_code = this.cvv;
                }

                data.lang = "ja";
                let url = process.env.MIX_PAYMENT_VERITRANS_LINK+`/4gtoken`;
                var card_no = this.card_no;
                var valid_date = this.valid_date;
                var cvv = this.cvv;
                var e_mail = this.e_mail;

                axios.post(url,
                    {
                        card_number : this.card_no,
                        card_expire : this.valid_date.substring(0,2)+"/"+this.valid_date.substring(2,4),
                        security_code : this.cvv,
                        lang : "ja",
                        token_api_key : document.getElementById('token_api_key').value
                    },{})
                    .then(response => {
                        if(response.data.code == "success"){
                            token = response.token;
                            axios.post(process.env.MIX_BACK_URL+'/api/AspayCallBack',
                                {
                                    seq_os : this.request["order_seq"],
                                    amount : this.total_amt,
                                    card_no : this.card_no,
                                    e_mail : this.e_mail,
                                    valid_date : this.valid_date,
                                    cvv : this.cvv,
                                    kind : 3,
                                    payeasySelect : this.payeasySelect,
                                    cvsServiceOptionType : this.cvsSelect,
                                    token : response.data.token,
                                    bankKana : "",
                                    PaymentID : this.request["payment_id"],
                                    admits_day : this.admits_day
                                },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }})
                                .then(response => {
                                    if(response.data.ord_no && response.data.result == "1"){
                                        location.href="/payResult?kind=success&order_no=" + response.data.ord_no;
                                    }else{
                                        this.loading = false;
                                        if(response.data.msg != ""){
                                            this.loading = false;
                                            VueSimpleAlert.alert(response.data.msg,"","",{confirmButtonText:"確認"});
                                        }else{
                                            alert("결제 실패");
                                            this.loading = false;
                                        }
                                    }
                                });
                        }else{
                            this.loading = false;
                            VueSimpleAlert.alert(response.data.message,"","",{confirmButtonText:"確認"});

                        }
                    })
                    .catch(error =>{
                        if( error.response ){
                            VueSimpleAlert.alert(error.response.data.message,"","",{confirmButtonText:"確認"});
                        }
                        this.loading = false;
                    });
                ;
            }
            if(this.key == 2){
                if(this.payeasySelect == "ATM"){
                    pay_kind = "A";
                }
                if(this.payeasySelect == "netbank-pc"){
                    pay_kind = 6;
                }
                this.pay_card(pay_kind,token);
            }
            if(this.key == 3){
                pay_kind = "7";
                this.pay_card(pay_kind,token);
            }
        },
        pay_card(pay_kind,token){
            this.loading = true;

            axios.post(process.env.MIX_BACK_URL+'/api/AspayCallBack',
                {
                    seq_os : this.request["order_seq"],
                    amount : this.total_amt,
                    card_no : this.card_no,
                    e_mail : this.e_mail,
                    valid_date : this.valid_date,
                    cvv : this.cvv,
                    price_open : this.price_open,
                    kind : pay_kind,
                    payeasySelect : this.payeasySelect,
                    cvsServiceOptionType : this.cvsSelect,
                    token : token,
                    bankKana : this.bankKana,
                    PaymentID : this.request["payment_id"]
                },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }})
                .then(response => {
                    if(response.data.ord_no && response.data.result == "1"){
                        location.href="/payResult?kind=success&order_no=" + response.data.ord_no;
                    }else{
                        this.loading = false;
                        if(response.data.result == 6){
                            location.href=response.data.url;
                        }
                        else if(response.data.msg != ""){
                            this.loading = false;
                            VueSimpleAlert.alert(response.data.msg,"","",{confirmButtonText:"確認"});
                        }else{
                            alert("결제 실패");
                            this.loading = false;
                        }
                    }
                });
        },
        pay_proc(){
            let form = document.frmPayment;
            form.action = location.protocol.concat("//").concat(location.host)+"/aspay";
            form.method = "post";
            form._token.value = this.csrf;
            form.PaymentID.value = this.request["payment_id"];
            form.OrderNumber.value = this.request["order_seq"];
            form.Amount.value = this.request["pay_total_amt"];
            form.CustIP.value = window.Laravel.clientIp;
            form.CustName.value = this.request["name"]; //+' '+this.request["lastName"];
            form.CustEmail.value = this.request["email"]??$("#email").val();
            form.CustPhone.value =this.request["mobile"].replace(/-/g,""); //this.request["mobile"];
            form.HashValue.value = this.hashdata;
            form.MerchantReturnURL.value = location.protocol.concat("//").concat(location.host)+"/api/AspayResult";
            form.MerchantCallbackURL.value = process.env.MIX_BACK_URL+"/api/AspayCallBack";
            // form.MerchantCallbackURL.value = location.protocol.concat("//").concat(location.host)+"/api/payCallBack";
            console.log(form);
            form.submit();
        },
        pay_proc_manual(){
            if(this.check_agree_uselaw == "0"){
                alert.alert('The order can be processed only if you confirm acceptance of the purchase terms and conditions and grant your consent on proceeding with payment');
                return false;
            }
            let form = document.frmPayment;
            form.action = location.protocol.concat("//").concat(location.host)+"/asManualpay";
            form.method = "post";
            form.PymtMethod.value = "any";
            form._token.value = this.csrf;
            form.PaymentID.value = this.request["payment_id"];
            form.OrderNumber.value = this.request["order_seq"];
            form.Amount.value = this.request["pay_total_amt"];
            form.CustIP.value = window.Laravel.clientIp;
            form.CustName.value = this.request["name"]; //+' '+this.request["lastName"];
            form.CustEmail.value = this.request["email"]??$("#email").val();
            form.CustPhone.value =this.request["mobile"].replace(/-/g,""); //this.request["mobile"];
            form.HashValue.value = this.hashdata;
            form.MerchantReturnURL.value = location.protocol.concat("//").concat(location.host)+"/api/AspayResult";
            form.MerchantCallbackURL.value = process.env.MIX_BACK_URL+"/api/AspayCallBack";
            // form.MerchantCallbackURL.value = location.protocol.concat("//").concat(location.host)+"/api/payCallBack";
            console.log(form);
            form.submit();
        },
        close_address_search(){
            this.address_search_open = false;
        },
        close_guide(){
            this.guide_search_open = false;
        }


    }
}
</script>
